import React from 'react';
import PropTypes from 'prop-types';
// import AnchorTitle from '../../AnchorTitle';
import styles from './styles.module.styl';

const MicrositeSteps = (props) => {
  return (
    <React.Fragment>
      {/* Hide Steps Title for Now */}
      {/* <AnchorTitle title={props.title} tag="h3" /> */}
      <ol className={styles.list}>
        {props.steps.map((step, index) =>
          <li>
            <div className={styles.bullet}>
              <span>{index + 1}</span>
            </div>
            <div className={styles.step} dangerouslySetInnerHTML={{ __html: step }} />
          </li>
        )}
      </ol>
    </React.Fragment>
  );
};

MicrositeSteps.propTypes = {
  title: PropTypes.string.isRequired,
  steps: PropTypes.array.isRequired
};

MicrositeSteps.defaultProps = {
  title: 'Steps',
  steps: []
}

export default MicrositeSteps;
